"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Location = exports.LanguageDisplay = exports.Language = exports.CountryDisplay = exports.CountryUrl = exports.Country = void 0;
var Country;

(function (Country) {
  Country["us"] = "us";
  Country["ca"] = "ca";
  Country["mx"] = "mx";
  Country["cn"] = "cn";
})(Country || (exports.Country = Country = {}));

var CountryUrl;

(function (CountryUrl) {
  CountryUrl["us"] = "united-states";
  CountryUrl["ca"] = "canada";
  CountryUrl["mx"] = "mexico";
})(CountryUrl || (exports.CountryUrl = CountryUrl = {}));

var CountryDisplay;

(function (CountryDisplay) {
  CountryDisplay["us"] = "United States";
  CountryDisplay["ca"] = "Canada";
  CountryDisplay["mx"] = "Mexico";
  CountryDisplay["cn"] = "China";
})(CountryDisplay || (exports.CountryDisplay = CountryDisplay = {}));

var Language;

(function (Language) {
  Language["en"] = "en";
  Language["fr"] = "fr";
  Language["es"] = "es";
})(Language || (exports.Language = Language = {}));

var LanguageDisplay;

(function (LanguageDisplay) {
  LanguageDisplay["en"] = "English";
  LanguageDisplay["fr"] = "French";
  LanguageDisplay["es"] = "Spanish";
})(LanguageDisplay || (exports.LanguageDisplay = LanguageDisplay = {}));

var Location;

(function (Location) {
  Location["AL"] = "AL";
  Location["AK"] = "AK";
  Location["AZ"] = "AZ";
  Location["AR"] = "AR";
  Location["CA"] = "CA";
  Location["CO"] = "CO";
  Location["CT"] = "CT";
  Location["DE"] = "DE";
  Location["FL"] = "FL";
  Location["GA"] = "GA";
  Location["HI"] = "HI";
  Location["ID"] = "ID";
  Location["IL"] = "IL";
  Location["IN"] = "IN";
  Location["IA"] = "IA";
  Location["KS"] = "KS";
  Location["KY"] = "KY";
  Location["LA"] = "LA";
  Location["ME"] = "ME";
  Location["MD"] = "MD";
  Location["MA"] = "MA";
  Location["MI"] = "MI";
  Location["MN"] = "MN";
  Location["MS"] = "MS";
  Location["MO"] = "MO";
  Location["MT"] = "MT";
  Location["NE"] = "NE";
  Location["NV"] = "NV";
  Location["NH"] = "NH";
  Location["NJ"] = "NJ";
  Location["NM"] = "NM";
  Location["NY"] = "NY";
  Location["NC"] = "NC";
  Location["ND"] = "ND";
  Location["OH"] = "OH";
  Location["OK"] = "OK";
  Location["OR"] = "OR";
  Location["PA"] = "PA";
  Location["RI"] = "RI";
  Location["SC"] = "SC";
  Location["SD"] = "SD";
  Location["TN"] = "TN";
  Location["TX"] = "TX";
  Location["UT"] = "UT";
  Location["VT"] = "VT";
  Location["VA"] = "VA";
  Location["WA"] = "WA";
  Location["WV"] = "WV";
  Location["WI"] = "WI";
  Location["WY"] = "WY";
  Location["AB"] = "AB";
  Location["BC"] = "BC";
  Location["MB"] = "MB";
  Location["NB"] = "NB";
  Location["ON"] = "ON";
  Location["QC"] = "QC";
  Location["Hermosillo"] = "Hermosillo";
  Location["Monterrey"] = "Monterrey";
  Location["Queretaro"] = "Queretaro";
  Location["Tijuana"] = "Tijuana";
  Location["AllLocations"] = "AllLocations";
})(Location || (exports.Location = Location = {}));